module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/blogs/bravenet_blogs_seo_everywhere_web_presence.png";